import { useEffect, useState, useRef } from 'react';
import {
  TreeGridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Inject,
  Edit,
  Toolbar,
  RowDD,
} from '@syncfusion/ej2-react-treegrid';
import * as api from '../../../api/rodape';
import {
  Flex,
  Heading,
  Button,
  FormControl,
  FormLabel,
  Checkbox,
  Box,
  Text,
} from '@chakra-ui/react';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router';
import './rodape.scss';

interface MenuItem {
  ID: number;
  Name: string;
  ativo: boolean;
  hyperlink?: string;
  parentID?: any;
  subtasks?: MenuItem[];
}

interface CheckboxListProps {
  flatList: MenuItem[];
  handleCheckboxChange: (id: number) => void;
}

const FaixaNavegacaoPrincipal = () => {
  const navigate = useNavigate();
  const [menuData, setMenuData] = useState<MenuItem[]>([]);
  const treegridObj = useRef<TreeGridComponent>(null);
  const [flatList, setFlatList] = useState<MenuItem[]>([]);
  const [openDropdown, setOpenDropdown] = useState<number | null>(null);
  const [menuKey, setMenuKey] = useState(0);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    fetchMenus();
  }, []);

  const fetchMenus = async () => {
    const menus = await api.listarRodape();
    const formattedMenus = formatMenus(menus);
    setMenuData(formattedMenus);
    setFlatList(flattenMenu(formattedMenus));
  };

  const formatMenus = (menus: any[]): MenuItem[] => {
    const map = new Map<number, MenuItem>();
    const result: MenuItem[] = [];
    menus.forEach((menu: any) => {
      const item: MenuItem = {
        ID: menu.seqFaixaNavegacao,
        Name: menu.dsctituloMenu,
        hyperlink: menu.dscUrl,
        ativo: menu.numVisivel == 1,
        parentID: menu.fkSeqFaixaNavegacao ? menu.fkSeqFaixaNavegacao : null,
        subtasks: [],
      };
      map.set(menu.seqFaixaNavegacao, item);
    });
    menus.forEach((menu: any) => {
      const item = map.get(menu.seqFaixaNavegacao)!;
      if (menu.fkSeqFaixaNavegacao) {
        const parent = map.get(menu.fkSeqFaixaNavegacao);
        if (parent) {
          parent.subtasks?.push(item);
        }
      } else {
        result.push(item);
      }
    });
    return result;
  };
  const flattenMenu = (data: MenuItem[]): MenuItem[] => {
    const flatData: MenuItem[] = [];
    const traverse = (nodes: MenuItem[]) => {
      nodes.forEach((node) => {
        flatData.push(node);
        if (node.subtasks && node.subtasks.length > 0) {
          traverse(node.subtasks);
        }
      });
    };

    traverse(data);
    return flatData;
  };

  const handleCheckboxChange = (id: number) => {
    const updateAtivo = (items: MenuItem[]): MenuItem[] => {
      return items.map((item) => {
        if (item.ID === id) {
          return { ...item, ativo: !item.ativo };
        } else if (item.subtasks && item.subtasks.length > 0) {
          return { ...item, subtasks: updateAtivo(item.subtasks) };
        } else {
          return item;
        }
      });
    };
    setMenuData((prevData) => {
      const updatedData = updateAtivo(prevData);
      setFlatList(flattenMenu(updatedData));
      return updatedData;
    });
  };

  const handleRowDrop = () => {
    if (treegridObj.current) {
      const dataSource = treegridObj.current.dataSource as MenuItem[];
      setMenuData(dataSource);
      const flatData = flattenMenu(dataSource);
      setFlatList(flatData); setRefresh((prev) => prev + 1);
    }
  };

  const handleActionComplete = (args: any) => {
    if (args.requestType === 'save' || args.requestType === 'delete') {
      if (treegridObj.current) {
        const dataSource = treegridObj.current.dataSource as MenuItem[];
        setMenuData(dataSource);
        const flatData = flattenMenu(dataSource);
        setFlatList(flatData);
        setRefresh((prev) => prev + 1);
      }
    }
  }

  const handleSave = async () => {
    let order = 1;
    const traverseMenu = (menu: MenuItem[], parent: any = null): any[] => {
      const flattenedItems: any[] = [];
      menu.forEach((item: MenuItem) => {
        const newItem = {
          seqFaixaNavegacao: item.ID,
          fkSeqFaixaNavegacao: parent ? parent.seqFaixaNavegacao : null,
          dsctituloMenu: item.Name,
          dscUrl: item.hyperlink || null,
          numOrdem: order++,
          numLocal: 1,
          numVisivel: item.ativo ? 1 : 0,
        };
        flattenedItems.push(newItem);
        if (item.subtasks && item.subtasks.length > 0) {
          flattenedItems.push(...traverseMenu(item.subtasks, newItem));
        }
      });
      return flattenedItems;
    };
    const updatedMenuData = traverseMenu(menuData);
    try {
      await api.editarRodape(updatedMenuData);
      await fetchMenus();
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Rodapé alterado com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/edicao-cidade-inteligente');
      });
    } catch (error) {
      console.error('Erro ao alterar rodapé:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao alterar rodapé. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      });
    }
  };

  const CheckboxList: React.FC<CheckboxListProps> = ({ flatList, handleCheckboxChange }) => {
    return (
      <div style={{ marginTop: '0px' }}>
        <Box paddingLeft={'100px'}>
          <Text
            padding={'8px'}
            height="43px"
            borderTop="1px solid #e0e0e0"
            borderRight="1px solid #e0e0e0"
            marginLeft={'-100px'} className="texto-ativo" textAlign="center">
          </Text>
        </Box>
        <Box paddingLeft={'100px'}>
          <Text
            padding={'12px'}
            height="44px"
            borderBottom="1px solid #e0e0e0"
            borderTop="1px solid #e0e0e0"
            borderRight="1px solid #e0e0e0"
            marginLeft={'-100px'} className="texto-ativo" textAlign="center">
            Ativo
          </Text>
        </Box>
        {flatList.map((item, index) => (
          <Box
            className="responsive-box"
            key={`${item.ID}-${index}`}
            borderBottom="1px solid #e0e0e0"
            borderRight="1px solid #e0e0e0"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Checkbox
              isChecked={item.ativo}
              onChange={() => handleCheckboxChange(item.ID)}
            />
          </Box>
        ))}
      </div>
    );
  };

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <Heading
        mt="30px"
        mb="20px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Gerenciar Rodapé
      </Heading>
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <div style={{ flex: 1 }}>
          <TreeGridComponent
            dataSource={menuData}
            treeColumnIndex={1}
            childMapping="subtasks"
            enableHover={true}
            allowSelection={false}
            allowRowDragAndDrop={true}
            editSettings={{
              allowEditing: true,
              allowAdding: true,
              allowDeleting: true,
              mode: 'Cell',
              newRowPosition: 'Below',
            }}
            toolbar={['Add', 'Update', 'Cancel']}
            rowDrop={handleRowDrop}
            actionComplete={handleActionComplete}
            ref={treegridObj}
            locale="pt-BR"
            width="100%"
          >
            <ColumnsDirective>
              <ColumnDirective
                field="ID"
                headerText="ID"
                width="60"
                textAlign="Left"
                isPrimaryKey={true}
                allowEditing={false}
                visible={false}
              />
              <ColumnDirective
                field="Name"
                headerText="Título"
                width="200"
                textAlign="Left"
              />
              <ColumnDirective
                field="hyperlink"
                headerText="Hyperlink"
                width="200"
                textAlign="Left"
              />
            </ColumnsDirective>
            <Inject services={[Page, Edit, Toolbar, RowDD]} />
          </TreeGridComponent>
        </div>
        <CheckboxList
          key={refresh}
          flatList={flatList}
          handleCheckboxChange={handleCheckboxChange}
        />
      </div>

      <FormLabel mt="24px">Preview do Rodapé</FormLabel>
      <FormControl>
        {menuData.length > 0 && (
          <nav
            className="navbar navbar-expand-lg navbar-light"
            key={menuKey}
            style={{
              width: "100%",
              maxWidth: "100vw",
              whiteSpace: "nowrap",
              backgroundColor: "#ebebeb",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <div
              className="container-fluid"
              style={{ display: "flex", flexWrap: "wrap", width: "100%" }}
            >
              <div className="collapse navbar-collapse" style={{ width: "100%" }}>
                <ul
                  className="navbar-nav mr-auto"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: "16px",
                    width: "100%",
                  }}
                >
                  <li className="nav-item">
                    <a className="nav-link" style={{ cursor: "pointer" }}>
                      Home
                    </a>
                  </li>
                  {menuData
                    .filter((item) => item.ativo)
                    .map((item) => (
                      <li
                        className={`nav-item ${item.subtasks && item.subtasks.length > 0 ? "dropdown" : ""} ${openDropdown === item.ID ? "show" : ""}`}
                        key={item.ID}
                        onMouseEnter={() => setOpenDropdown(item.ID)}
                        onMouseLeave={() => setOpenDropdown(null)}
                      >
                        {item.subtasks && item.subtasks.length > 0 ? (
                          <>
                            <button className="btn dropdown-toggle" role="button">
                              {item.Name}
                            </button>
                            <ul className={`dropdown-menu ${openDropdown === item.ID ? "show" : ""}`}>
                              {item.subtasks
                                .filter((sub: any) => sub.ativo)
                                .map((sub: any) => (
                                  <li key={sub.ID}>
                                    <a className="dropdown-item" href={sub.hyperlink ? sub.hyperlink : "#"}>
                                      {sub.Name}
                                    </a>
                                  </li>
                                ))}
                            </ul>
                          </>
                        ) : (
                          <a className="nav-link" href={item.hyperlink ? item.hyperlink : "#"}>
                            {item.Name}
                          </a>
                        )}
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </nav>
        )}
      </FormControl>

      <Flex w="100%" justifyContent="flex-end" mt="20px">
        <Button
          type="submit"
          m="6px"
          color="#FFF"
          bgColor="#1665D8"
          _hover={{ opacity: 0.8 }}
          onClick={handleSave}
        >
          Salvar Rodapé
        </Button>
      </Flex>
    </Flex>
  );
};

export default FaixaNavegacaoPrincipal;
